import { clsx } from 'clsx'
import { Navigation } from 'component/Carousel/co/Navigation'
import { Slides } from 'component/Carousel/co/Slides'
import { CarouselStore } from 'component/Carousel/store/CarouselStore'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import css from './Carousel.module.scss'

type Props<T> = {
  store: CarouselStore<T>
  render: (item: T) => ReactElement
  arrows?: boolean
  one?: boolean
  center?: boolean
}

export const Carousel = observer(<T, >(props: Props<T>) => {
  const { store, arrows, one, center } = props
  const className = clsx(css.main, one && css.one)

  const render = useLatestCallback((item: T) => {
    return props.render(item)
  })

  return <Space className={className} center>
    <div className={css.view}>
      <Slides key={store.key} store={store} render={render} center={center} />
    </div>
    {arrows && store.many && <Navigation store={store} />}
  </Space>
})
